import i18n from 'i18next';
import axios from '../../../shared/utils/axios';
import { addToast } from '../toasts/toastsActions';
import { toastTypes } from '../../../shared/components/Toast/ToastOptions';

const INTEGRATIONS_ENDPOINT = `${process.env.REACT_APP_API_URL}integrations`;
const PIBLIC_API_ENDPOINT = `${INTEGRATIONS_ENDPOINT}/api/apikey`;

const getPublicApiKey = async () => {
  try {
    const response = await axios.get(PIBLIC_API_ENDPOINT, {});

    return response.data.status;
  } catch (error) {}
};

const deletePublicApiKey = async dispatch => {
  try {
    await axios.delete(PIBLIC_API_ENDPOINT, {});

    const message = i18n.t('integrations.default.sync.success', {
      ns: 'actions'
    });
    dispatch(addToast({ ...toastTypes.success, defaultMessage: message }));

    return true;
  } catch (error) {
    dispatch(addToast(toastTypes.error, error));
    return false;
  }
};

const createPublicApiKey = async dispatch => {
  try {
    const apiKeyRequest = await axios.post(PIBLIC_API_ENDPOINT, { type: 'permanent' });

    const message = i18n.t('integrations.default.sync.success', {
      ns: 'actions'
    });
    dispatch(addToast({ ...toastTypes.success, defaultMessage: message }));

    return apiKeyRequest?.data?.apiKey;
  } catch (error) {
    dispatch(addToast(toastTypes.error, error));
  }
};

const createEphemeralApiKey = async dispatch => {
  try {
    const response = await axios.post(PIBLIC_API_ENDPOINT, { type: 'ephemeral' });

    const message = i18n.t('integrations.default.sync.success', {
      ns: 'actions'
    });
    dispatch(addToast({ ...toastTypes.success, defaultMessage: message }));

    return { apiKey: response.data.apiKey, expiresAt: response.data.expiresAt };
  } catch (error) {
    dispatch(addToast(toastTypes.error, error));
  }
};

const publicApiActions = {
  getPublicApiKey,
  deletePublicApiKey,
  createPublicApiKey,
  createEphemeralApiKey
};

export default publicApiActions;
